import { Injectable, signal } from '@angular/core';

export interface Toast {
  id: number;
  kind: 'error' | 'success' | 'info';
  message: string;
}

@Injectable({ providedIn: 'root' })
export class NotificationService {
  private nextId = 1;
  readonly toasts = signal<Toast[]>([]);

  error(message: string): void {
    this.push('error', message, 9000);
  }

  success(message: string): void {
    this.push('success', message, 4000);
  }

  info(message: string): void {
    this.push('info', message, 4000);
  }

  dismiss(id: number): void {
    this.toasts.update((all) => all.filter((t) => t.id !== id));
  }

  private push(kind: Toast['kind'], message: string, ttlMs: number): void {
    const id = this.nextId++;
    this.toasts.update((all) => [...all, { id, kind, message }]);
    setTimeout(() => this.dismiss(id), ttlMs);
  }
}
